import en from './resources/en.json'

export default {
  en: {
    translation: {
      ...en,
    },
  },
}
